module.exports = __webpack_public_path__ + "static/media/logo-rounded.5fa86825.png";